import { use } from "react";
import clsx from "clsx";

import { useBookmarks, useMutateBookmarks } from "lib/bookmarks/use-bookmarks";
import { useTranslation } from "lib/i18n/use-translation";
import { NavigationContext } from "lib/navigation/use-navigation";
import { usePaths } from "lib/navigation/use-paths";
import { NotificationsContext } from "lib/notifications/use-notifications";

import BookmarkFilledIcon from "assets/icons/bookmark-filled.svg?react";
import BookmarkIcon from "assets/icons/bookmark.svg?react";
import css from "./bookmark.module.scss";

export function Bookmark() {
  const { bookmarks } = useBookmarks();
  const { bookmarkPage, deleteBookmark } = useMutateBookmarks();
  const { page } = use(NavigationContext)!;
  const { getXpointersOnPage } = usePaths();

  const { showBookmarkNotification, showToast } = use(NotificationsContext)!;
  const { t } = useTranslation();

  const xpointersOnPage = getXpointersOnPage(page);
  const currentBookmark = bookmarks.find(b =>
    xpointersOnPage.includes(b.xpointer)
  );

  async function onClick() {
    if (currentBookmark) {
      const [, error] = await deleteBookmark(currentBookmark.id);
      if (error) {
        showToast(t("Не удалось удалить закладку"));
      } else {
        showBookmarkNotification("deleted");
      }
    } else {
      const [, error] = await bookmarkPage();
      if (error) {
        showToast(t("Не удалось сохранить закладку"));
      } else {
        showBookmarkNotification("added");
      }
    }
  }

  const title = currentBookmark
    ? t("Удалить закладку")
    : t("Добавить закладку");

  return (
    <div>
      <button
        onClick={onClick}
        className={clsx(css.trigger, currentBookmark && css.active)}
        aria-label={title}
        aria-pressed={Boolean(currentBookmark)}
        title={title}
        data-testid="bookmarkButton"
      >
        {currentBookmark ? (
          <BookmarkFilledIcon width={24} height={24} />
        ) : (
          <BookmarkIcon width={24} height={24} />
        )}
      </button>
    </div>
  );
}
